import React from 'react';

const ParentCalendarEvents = () => (
  <div style={{ padding: 6 }}>
    <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e3a5f', marginBottom: 10 }}>Calendar</h1>
    <p style={{ fontSize: 14, color: '#64748b', marginBottom: 18 }}>
      Browse upcoming school events and RSVP to family activities.
    </p>

    <div style={{ display: 'grid', gap: 18 }}>
      <section style={{ borderRadius: 18, padding: 18, background: '#f8fafc', border: '1px solid #dbeafe', boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)' }}>
        <div style={{ background: '#2563eb', borderRadius: 14, color: 'white', padding: '12px 16px', fontWeight: 700, marginBottom: 16 }}>October 2026</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: 4, marginBottom: 16 }}>
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
            <div key={day} style={{ fontSize: 11, color: '#334155', textAlign: 'center', fontWeight: 700 }}>{day}</div>
          ))}
          {Array.from({ length: 31 }, (_, idx) => (
            <div
              key={idx}
              style={{
                minHeight: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 10,
                background: idx === 13 ? '#2563eb' : '#ffffff',
                color: idx === 13 ? '#ffffff' : '#0f172a',
                fontSize: 12,
                border: '1px solid #e2e8f0',
              }}
            >
              {idx + 1}
            </div>
          ))}
        </div>

        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #c7d2fe', padding: 18 }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Halloween Party</div>
          <div style={{ fontSize: 13, color: '#475569', marginBottom: 4 }}>When: 1:00-2:15 PM</div>
          <div style={{ fontSize: 13, color: '#475569', marginBottom: 4 }}>Where: Room 337</div>
          <div style={{ fontSize: 13, color: '#475569' }}>Contact: Jenny Brinker</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 14 }}>
            <button style={{ background: '#2563eb', color: 'white', border: 'none', borderRadius: 10, padding: '10px 16px', fontWeight: 700, cursor: 'pointer' }}>RSVP</button>
            <button style={{ background: '#e2e8f0', color: '#1e3a8a', border: 'none', borderRadius: 10, padding: '10px 16px', fontWeight: 700, cursor: 'pointer' }}>Sign Up</button>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default ParentCalendarEvents;
